import { render, staticRenderFns } from "./allocatedSuccess.vue?vue&type=template&id=446d37e2&scoped=true&"
import script from "./allocatedSuccess.vue?vue&type=script&lang=js&"
export * from "./allocatedSuccess.vue?vue&type=script&lang=js&"
import style0 from "./allocatedSuccess.vue?vue&type=style&index=0&id=446d37e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d37e2",
  null
  
)

export default component.exports